// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: linear-gradient(to right, #001a33, #003366);
  padding: 0;
  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;
  position: relative;
  width: 100%;
  color: white;
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.1);
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px 20px;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 30px;
}

.footer-brand {
  flex: 1 1;
  min-width: 250px;
}

.footer-brand h3 {
  font-size: 1.8rem;
  margin: 0 0 15px;
  font-weight: 700;
  background: linear-gradient(90deg, #ffffff, #66ccff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.footer-brand p {
  font-size: 0.95rem;
  line-height: 1.5;
  opacity: 0.8;
  margin: 0;
}

.footer-links {
  display: flex;
  gap: 40px;
  flex: 2 1;
  justify-content: space-around;
}

.footer-links-column {
  display: flex;
  flex-direction: column;
}

.footer-links-column h4 {
  font-size: 1.1rem;
  margin: 0 0 15px;
  font-weight: 600;
  color: #66ccff;
}

.footer-links-column a {
  color: white !important;
  text-decoration: none;
  margin-bottom: 10px;
  font-size: 0.9rem;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.footer-links-column a:hover {
  opacity: 1;
  transform: translateX(5px);
  color: #66ccff;
}

.footer-newsletter {
  flex: 1 1;
  min-width: 250px;
}

.footer-newsletter h4 {
  font-size: 1.1rem;
  margin: 0 0 15px;
  font-weight: 600;
  color: #66ccff;
}

.footer-newsletter p {
  font-size: 0.9rem;
  line-height: 1.5;
  opacity: 0.8;
  margin-bottom: 15px;
}

.newsletter-form {
  display: flex;
  height: 40px;
}

.newsletter-form input {
  flex: 1 1;
  padding: 0 15px;
  border: none;
  border-radius: 4px 0 0 4px;
  font-size: 0.9rem;
  outline: none;
}

.newsletter-form button {
  width: 50px;
  background: #0066cc;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.newsletter-form button:hover {
  background: #0099ff;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 20px 0;
}

.footer-bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
}

.footer-social {
  display: flex;
  gap: 15px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background: #0066cc;
  transform: translateY(-5px);
}

.footer-copyright {
  font-size: 0.85rem;
  opacity: 0.7;
}

.heart-icon {
  color: #ff3366;
  margin: 0 5px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .footer-top {
    flex-direction: column;
    gap: 30px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 20px;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .footer-social {
    justify-content: center;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,uDAAuD;EACvD,UAAU;EACV,qDAAqD;EACrD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".footer {\n  background: linear-gradient(to right, #001a33, #003366);\n  padding: 0;\n  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;\n  position: relative;\n  width: 100%;\n  color: white;\n  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.1);\n}\n\n.footer-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px 20px;\n}\n\n.footer-top {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 40px;\n  margin-bottom: 30px;\n}\n\n.footer-brand {\n  flex: 1;\n  min-width: 250px;\n}\n\n.footer-brand h3 {\n  font-size: 1.8rem;\n  margin: 0 0 15px;\n  font-weight: 700;\n  background: linear-gradient(90deg, #ffffff, #66ccff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.footer-brand p {\n  font-size: 0.95rem;\n  line-height: 1.5;\n  opacity: 0.8;\n  margin: 0;\n}\n\n.footer-links {\n  display: flex;\n  gap: 40px;\n  flex: 2;\n  justify-content: space-around;\n}\n\n.footer-links-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-links-column h4 {\n  font-size: 1.1rem;\n  margin: 0 0 15px;\n  font-weight: 600;\n  color: #66ccff;\n}\n\n.footer-links-column a {\n  color: white !important;\n  text-decoration: none;\n  margin-bottom: 10px;\n  font-size: 0.9rem;\n  opacity: 0.8;\n  transition: all 0.3s ease;\n}\n\n.footer-links-column a:hover {\n  opacity: 1;\n  transform: translateX(5px);\n  color: #66ccff;\n}\n\n.footer-newsletter {\n  flex: 1;\n  min-width: 250px;\n}\n\n.footer-newsletter h4 {\n  font-size: 1.1rem;\n  margin: 0 0 15px;\n  font-weight: 600;\n  color: #66ccff;\n}\n\n.footer-newsletter p {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  opacity: 0.8;\n  margin-bottom: 15px;\n}\n\n.newsletter-form {\n  display: flex;\n  height: 40px;\n}\n\n.newsletter-form input {\n  flex: 1;\n  padding: 0 15px;\n  border: none;\n  border-radius: 4px 0 0 4px;\n  font-size: 0.9rem;\n  outline: none;\n}\n\n.newsletter-form button {\n  width: 50px;\n  background: #0066cc;\n  color: white;\n  border: none;\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.newsletter-form button:hover {\n  background: #0099ff;\n}\n\n.footer-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n  margin: 20px 0;\n}\n\n.footer-bottom {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 20px;\n}\n\n.footer-social {\n  display: flex;\n  gap: 15px;\n}\n\n.social-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  color: white;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n}\n\n.social-icon:hover {\n  background: #0066cc;\n  transform: translateY(-5px);\n}\n\n.footer-copyright {\n  font-size: 0.85rem;\n  opacity: 0.7;\n}\n\n.heart-icon {\n  color: #ff3366;\n  margin: 0 5px;\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-top {\n    flex-direction: column;\n    gap: 30px;\n  }\n  \n  .footer-links {\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .footer-bottom {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n  \n  .footer-social {\n    justify-content: center;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
